package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class PortfolioPieceCompetenceQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    piece_id: String,
    competence_id: String,
    criterion_id: String?,
    note: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_999_529_052, arrayOf("portfolio_piece_competence"), driver,
      "PortfolioPieceCompetence.sq", "selectAll",
      "SELECT portfolio_piece_competence.id, portfolio_piece_competence.piece_id, portfolio_piece_competence.competence_id, portfolio_piece_competence.criterion_id, portfolio_piece_competence.note, portfolio_piece_competence.order_index, portfolio_piece_competence.created_at, portfolio_piece_competence.updated_at, portfolio_piece_competence.is_deleted, portfolio_piece_competence.deleted_at, portfolio_piece_competence.synced_at FROM portfolio_piece_competence WHERE is_deleted = 0 ORDER BY piece_id, order_index") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectAll(): Query<Portfolio_piece_competence> = selectAll { id, piece_id,
      competence_id, criterion_id, note, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Portfolio_piece_competence(
      id,
      piece_id,
      competence_id,
      criterion_id,
      note,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    piece_id: String,
    competence_id: String,
    criterion_id: String?,
    note: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectById(id: String): Query<Portfolio_piece_competence> = selectById(id) { id_,
      piece_id, competence_id, criterion_id, note, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Portfolio_piece_competence(
      id_,
      piece_id,
      competence_id,
      criterion_id,
      note,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByPiece(piece_id: String, mapper: (
    id: String,
    piece_id: String,
    competence_id: String,
    criterion_id: String?,
    note: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByPieceQuery(piece_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectByPiece(piece_id: String): Query<Portfolio_piece_competence> =
      selectByPiece(piece_id) { id, piece_id_, competence_id, criterion_id, note, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Portfolio_piece_competence(
      id,
      piece_id_,
      competence_id,
      criterion_id,
      note,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByPieceAnyState(piece_id: String, mapper: (
    id: String,
    piece_id: String,
    competence_id: String,
    criterion_id: String?,
    note: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByPieceAnyStateQuery(piece_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectByPieceAnyState(piece_id: String): Query<Portfolio_piece_competence> =
      selectByPieceAnyState(piece_id) { id, piece_id_, competence_id, criterion_id, note,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Portfolio_piece_competence(
      id,
      piece_id_,
      competence_id,
      criterion_id,
      note,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByCompetence(competence_id: String, mapper: (
    id: String,
    piece_id: String,
    competence_id: String,
    criterion_id: String?,
    note: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByCompetenceQuery(competence_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectByCompetence(competence_id: String): Query<Portfolio_piece_competence> =
      selectByCompetence(competence_id) { id, piece_id, competence_id_, criterion_id, note,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Portfolio_piece_competence(
      id,
      piece_id,
      competence_id_,
      criterion_id,
      note,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    piece_id: String,
    competence_id: String,
    criterion_id: String?,
    note: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_699_728_333, arrayOf("portfolio_piece_competence"), driver,
      "PortfolioPieceCompetence.sq", "selectDirty",
      "SELECT portfolio_piece_competence.id, portfolio_piece_competence.piece_id, portfolio_piece_competence.competence_id, portfolio_piece_competence.criterion_id, portfolio_piece_competence.note, portfolio_piece_competence.order_index, portfolio_piece_competence.created_at, portfolio_piece_competence.updated_at, portfolio_piece_competence.is_deleted, portfolio_piece_competence.deleted_at, portfolio_piece_competence.synced_at FROM portfolio_piece_competence WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectDirty(): Query<Portfolio_piece_competence> = selectDirty { id, piece_id,
      competence_id, criterion_id, note, order_index, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Portfolio_piece_competence(
      id,
      piece_id,
      competence_id,
      criterion_id,
      note,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    piece_id: String,
    competence_id: String,
    criterion_id: String?,
    note: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3),
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Portfolio_piece_competence> =
      selectByIdAnyState(id) { id_, piece_id, competence_id, criterion_id, note, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Portfolio_piece_competence(
      id_,
      piece_id,
      competence_id,
      criterion_id,
      note,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    piece_id: String,
    competence_id: String,
    criterion_id: String?,
    note: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-60_583_742, """
        |INSERT INTO portfolio_piece_competence(id, piece_id, competence_id, criterion_id, note, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 8) {
          bindString(0, id)
          bindString(1, piece_id)
          bindString(2, competence_id)
          bindString(3, criterion_id)
          bindString(4, note)
          bindLong(5, order_index)
          bindLong(6, created_at)
          bindLong(7, updated_at)
        }
    notifyQueries(-60_583_742) { emit ->
      emit("portfolio_piece_competence")
    }
  }

  public fun update(
    piece_id: String,
    competence_id: String,
    criterion_id: String?,
    note: String?,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(284_362_450, """
        |UPDATE portfolio_piece_competence
        |SET piece_id = ?, competence_id = ?, criterion_id = ?, note = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 7) {
          bindString(0, piece_id)
          bindString(1, competence_id)
          bindString(2, criterion_id)
          bindString(3, note)
          bindLong(4, order_index)
          bindLong(5, updated_at)
          bindString(6, id)
        }
    notifyQueries(284_362_450) { emit ->
      emit("portfolio_piece_competence")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_378_172_930,
        """UPDATE portfolio_piece_competence SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_378_172_930) { emit ->
      emit("portfolio_piece_competence")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(1_557_251_493,
        """UPDATE portfolio_piece_competence SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(1_557_251_493) { emit ->
      emit("portfolio_piece_competence")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-175_279_312,
        """UPDATE portfolio_piece_competence SET synced_at = ? WHERE id = ? AND updated_at <= ?""",
        3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-175_279_312) { emit ->
      emit("portfolio_piece_competence")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("portfolio_piece_competence", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("portfolio_piece_competence", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_855_899_767,
        """SELECT portfolio_piece_competence.id, portfolio_piece_competence.piece_id, portfolio_piece_competence.competence_id, portfolio_piece_competence.criterion_id, portfolio_piece_competence.note, portfolio_piece_competence.order_index, portfolio_piece_competence.created_at, portfolio_piece_competence.updated_at, portfolio_piece_competence.is_deleted, portfolio_piece_competence.deleted_at, portfolio_piece_competence.synced_at FROM portfolio_piece_competence WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "PortfolioPieceCompetence.sq:selectById"
  }

  private inner class SelectByPieceQuery<out T : Any>(
    public val piece_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("portfolio_piece_competence", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("portfolio_piece_competence", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(2_671_122,
        """SELECT portfolio_piece_competence.id, portfolio_piece_competence.piece_id, portfolio_piece_competence.competence_id, portfolio_piece_competence.criterion_id, portfolio_piece_competence.note, portfolio_piece_competence.order_index, portfolio_piece_competence.created_at, portfolio_piece_competence.updated_at, portfolio_piece_competence.is_deleted, portfolio_piece_competence.deleted_at, portfolio_piece_competence.synced_at FROM portfolio_piece_competence WHERE piece_id = ? AND is_deleted = 0 ORDER BY order_index""",
        mapper, 1) {
      bindString(0, piece_id)
    }

    override fun toString(): String = "PortfolioPieceCompetence.sq:selectByPiece"
  }

  private inner class SelectByPieceAnyStateQuery<out T : Any>(
    public val piece_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("portfolio_piece_competence", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("portfolio_piece_competence", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_888_312_777,
        """SELECT portfolio_piece_competence.id, portfolio_piece_competence.piece_id, portfolio_piece_competence.competence_id, portfolio_piece_competence.criterion_id, portfolio_piece_competence.note, portfolio_piece_competence.order_index, portfolio_piece_competence.created_at, portfolio_piece_competence.updated_at, portfolio_piece_competence.is_deleted, portfolio_piece_competence.deleted_at, portfolio_piece_competence.synced_at FROM portfolio_piece_competence WHERE piece_id = ?""",
        mapper, 1) {
      bindString(0, piece_id)
    }

    override fun toString(): String = "PortfolioPieceCompetence.sq:selectByPieceAnyState"
  }

  private inner class SelectByCompetenceQuery<out T : Any>(
    public val competence_id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("portfolio_piece_competence", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("portfolio_piece_competence", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(182_728_485,
        """SELECT portfolio_piece_competence.id, portfolio_piece_competence.piece_id, portfolio_piece_competence.competence_id, portfolio_piece_competence.criterion_id, portfolio_piece_competence.note, portfolio_piece_competence.order_index, portfolio_piece_competence.created_at, portfolio_piece_competence.updated_at, portfolio_piece_competence.is_deleted, portfolio_piece_competence.deleted_at, portfolio_piece_competence.synced_at FROM portfolio_piece_competence WHERE competence_id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, competence_id)
    }

    override fun toString(): String = "PortfolioPieceCompetence.sq:selectByCompetence"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("portfolio_piece_competence", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("portfolio_piece_competence", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_099_068_316,
        """SELECT portfolio_piece_competence.id, portfolio_piece_competence.piece_id, portfolio_piece_competence.competence_id, portfolio_piece_competence.criterion_id, portfolio_piece_competence.note, portfolio_piece_competence.order_index, portfolio_piece_competence.created_at, portfolio_piece_competence.updated_at, portfolio_piece_competence.is_deleted, portfolio_piece_competence.deleted_at, portfolio_piece_competence.synced_at FROM portfolio_piece_competence WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "PortfolioPieceCompetence.sq:selectByIdAnyState"
  }
}
